import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
declare const $:any;


@Component({
  selector: "nv-button",
  templateUrl: "./nv-button.component.html"
})
export class NvButtonComponent implements OnInit {
  private unsubscribe: Subject<void> = new Subject<void>();
  private lastNewDocumentEvent: INewDocumentEvent;

  @Input() plus: boolean;
  @Input() ignoreDocumentReadonlyFlag: boolean = false;
  @Input() btnClass: string = "btn-primary";

  @Output() onClick = new EventEmitter();

  @ViewChild("buttonNode") element: ElementRef;


  constructor(private busService: BusService) {
  }


  ngOnInit(): void {
    this.busService
      .onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.onDocumentUpdated(e));
  }


  localOnClick() {
    this.onClick.emit();
  }


  private onDocumentUpdated(e: INewDocumentEvent) {
    this.lastNewDocumentEvent = e;
    this.updateNodeState();
  }


  private updateNodeState() {
    if (this.ignoreDocumentReadonlyFlag) { return; }
    if (!this.element) { return; }

    if (this.lastNewDocumentEvent.readonly) {
      $(this.element.nativeElement).prop("disabled", true);
    } else {
      $(this.element.nativeElement).prop("disabled", false);
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-button/nv-button.component.ts